<script>
export default {
  name: "custom-message",
  data: function() {
    return {
      timeout: 5000,
    };
  },
  methods: {
    onClose: function() {
      this.$store.commit("clearMessage");
    },
    onInput() {
      var self = this;
      setTimeout(self.onClose(), self.getTimeout);
    },
  },
  computed: {
    content: function() {
      return this.$store.state.userMessage ? this.$store.state.userMessage.content : "";
    },
    messageType: function() {
      return this.$store.state.userMessage ? this.$store.state.userMessage.type : "";
    },
    messageVisible() {
      return this.$store.state.userMessage && this.$store.state.userMessage.content ? true : false;
    },
    color() {
      var type = this.messageType;
      switch (type) {
        case "info":
          return "grey";
          break;
        case "error":
          return "red";
          break;
        case "success":
          return "green";
          break;
        case "warning":
          return "orange";
          break;
        default:
          return "grey";
      }
    },
    getTimeout() {
      if (this.messageType != "error") {
        return this.timeout;
      } else {
        return 20000;
      }
    },
  },
};
</script>
<template>
  <v-snackbar v-model="messageVisible" :timeout="getTimeout" v-on:input="onInput()" :color="color">
    <span v-html="content"></span>
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="onClose">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>
